import { SETTEXT, WORKERLOOKUP, FETCH } from './actionType'

// initialState shows what we are going to change
const initialState = {
  // empty text field
  inputText: '',
  // empty data field
  data: null,
  // API call
  fetching: false,
}

// Checks the type of the action and returns the appropriate state
export default function workerLookupReducer(state = initialState, action) {
  switch (action.type) {
    case FETCH:
      // Boolean describing if the data is being gathered
      return Object.assign({}, state, {
        fetching: action.fetching,
      })
    case SETTEXT:
      // First 2 params copy over empty data, third param overrides
      return Object.assign({}, state, {
        inputText: action.data,
      })
    case WORKERLOOKUP:
      return Object.assign({}, state, {
        inputText: '',
        data: action.data,
      })
    default:
      // returns state as is without changes
      return state
  }
}
